import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { logOut } from '../../store/auth/authSlice'

const useAutoLogout = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    let logoutTimer: any

    const resetTimeout = () => {
      if (logoutTimer) {
        clearTimeout(logoutTimer)
      }

      logoutTimer = setTimeout(() => {
        dispatch(logOut())
        navigate('/login')
      }, 1 * 60 * 60 * 1000) // 1h
    }

    const handleUserActivity = () => {
      resetTimeout()
    }

    resetTimeout()

    document.addEventListener('mousemove', handleUserActivity)
    document.addEventListener('keydown', handleUserActivity)

    return () => {
      document.removeEventListener('mousemove', handleUserActivity)
      document.removeEventListener('keydown', handleUserActivity)
      clearTimeout(logoutTimer)
    }
  }, [])

  return {}
}

export default useAutoLogout
